export default "__VITE_ASSET__fefb0459__"